import {Button, ButtonGroup, FormControl, FormHelperText, Link, TextField, Typography} from '@material-ui/core';
import 'Agent/AgentForms/Marketing/components/MarketingViewCart.sass';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from '../../../../rootReducer';
import {
  changeMissingRequiredFields,
  changeShippingPriority,
  changeViewCart,
  RequiredCheckoutCartFields,
  cartDataCopyHandlerShippingDetails,
} from '../ducks/Marketing';

const VCShippingDetails = () => {
  const {viewCart, shippingPriority, missingRequiredFields} = useSelector((state: ReducerState) => state.marketing);
  const [shipMethod, setShipMethod] = useState(shippingPriority);
  const [cartDataCopy, setCartDataCopy] = useState({...viewCart});
  const dispatch = useDispatch();

  const setHandler = cartDataCopyHandlerShippingDetails(setCartDataCopy, cartDataCopy);

  useEffect(() => {
    dispatch(changeShippingPriority(shipMethod));
  }, [shipMethod]);

  useEffect(() => {
    dispatch(changeViewCart({...viewCart, shipPriority: shippingPriority}));
  }, [cartDataCopy]);

  const handleShipMethod = (e: string) => {
    dispatch(changeShippingPriority(e));
    setCartDataCopy({...cartDataCopy, shipPriority: e});
    dispatch(changeViewCart({...cartDataCopy}));
  };

  const clearPreviousErrors = () => {
    dispatch(
      changeMissingRequiredFields([
        ...missingRequiredFields.filter(
          fieldName =>
            fieldName !== RequiredCheckoutCartFields.FEDEX_NAME &&
            fieldName !== RequiredCheckoutCartFields.FEDEX_ACCOUNT_NUMBER
        ),
      ])
    );
  };

  function dispatchChange() {
    setCartDataCopy(cartDataCopy);
    dispatch(changeViewCart({...cartDataCopy}));
  }

  return (
    <div style={{width: '90%', marginLeft: '1rem'}}>
      <FormControl fullWidth={true}>
        <Typography variant="subtitle1" style={{fontWeight: 600, color: 'Black'}}>
          Select your shipping method; allow 1-2 weeks for Standard shipping:
        </Typography>
      </FormControl>
      <ButtonGroup
        color="primary"
        aria-label="shipping method"
        className="button-section field-section-account"
        fullWidth={true}
        style={{border: '1px solid blue', borderRadius: '6px'}}
      >
        <Button
          id="btnShippingDetailsStandard"
          color="primary"
          variant="contained"
          disabled={shippingPriority === 'Standard'}
          onClick={e => handleShipMethod('Standard')}
        >
          Standard
        </Button>
        <Button
          id="btnShippingDetailsSecondDayAir"
          color="primary"
          variant="contained"
          disabled={shippingPriority === '2nd Day Air'}
          onClick={e => {
            clearPreviousErrors();
            handleShipMethod('2nd Day Air');
          }}
        >
          2nd Day Air
        </Button>
        <Button
          id="btnShippingDetailsOvernight"
          color="primary"
          variant="contained"
          disabled={shippingPriority === 'Overnight'}
          onClick={e => {
            clearPreviousErrors();
            handleShipMethod('Overnight');
          }}
        >
          Overnight
        </Button>
      </ButtonGroup>
      <FormHelperText style={{margin: '0.5rem 0 0.5rem 0.5rem'}}>
        The Standard will pay shipping for FedEx STANDARD GROUND charges. If you think you will need supplies faster than FedEx
        STANDARD GROUND can provide, we will send your order via FedEx 2ND DAY or OVERNIGHT EXPRESS under the following
        conditions: You have an active account with FedEx and you complete the section below with your billing
        information for the 2ND DAY or OVERNIGHT EXPRESS shipping charges. Otherwise, all orders must be sent FedEx
        STANDARD GROUND SHIPPING.
      </FormHelperText>
      <>
        {shippingPriority === 'Overnight' || shippingPriority === '2nd Day Air' ? (
          <>
            <FormHelperText style={{margin: '0.5rem 0 0.5rem 0.5rem'}}>
              If you do not have a FedEx account, please click on the following link:
              <Link target="_blank" rel="noopener" href="https://www.fedex.com/global/choose-location.html">
                www.FedEx.com{' '}
              </Link>
            </FormHelperText>
            <FormControl className="field-section-account" fullWidth={true}>
              <TextField
                variant="outlined"
                id="fedExNameText"
                label={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.FEDEX_NAME) && cartDataCopy.fedExName === ''
                    ? 'FedEx Name is required'
                    : 'FedEx Account Name'
                }
                placeholder="FedEx Account Name"
                name="fedExName"
                error={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.FEDEX_NAME) && cartDataCopy.fedExName === ''
                }
                value={cartDataCopy.fedExName}
                onChange={e => setHandler(e)}
                onBlur={e => dispatchChange()}
              />
            </FormControl>
            <FormControl className="field-section-account" fullWidth={true}>
              <TextField
                variant="outlined"
                label={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.FEDEX_ACCOUNT_NUMBER) &&
                  cartDataCopy.fedExNumber === ''
                    ? 'Account Number is required'
                    : 'FedEx Account Number'
                }
                placeholder="FedEx Account Number"
                name="fedExNumber"
                error={
                  missingRequiredFields.includes(RequiredCheckoutCartFields.FEDEX_ACCOUNT_NUMBER) &&
                  cartDataCopy.fedExNumber === ''
                }
                value={cartDataCopy.fedExNumber}
                onChange={e => setHandler(e)}
                onBlur={e => dispatchChange()}
              />
            </FormControl>
          </>
        ) : null}
      </>
      <FormControl className="field-section-account" fullWidth={true}>
        <TextField
          variant="outlined"
          label="Special Instructions"
          multiline
          rows={5}
          placeholder="Special Instructions"
          name="instructions"
          value={cartDataCopy.instructions}
          onChange={e => setHandler(e)}
          onBlur={e => dispatchChange()}
        />
      </FormControl>
      <>
        {shipMethod === 'Overnight' || shipMethod === '2nd Day Air' ? (
          <FormHelperText style={{color: '#0033a0'}}>Optional</FormHelperText>
        ) : null}
      </>
    </div>
  );
};

export default VCShippingDetails;
